import { Text } from '@akin-home/text/native';
import { TouchableOpacityProps } from 'react-native';
import styled from 'styled-components/native';

export const ButtonTransparentWhite = ({
  children,
  ...props
}: TouchableOpacityProps) => {
  return (
    <Container {...(props as any)}>
      <Text color="white" weight="semibold">
        {children}
      </Text>
    </Container>
  );
};

const Container = styled.TouchableOpacity`
  border-color: white;
  border-width: 2px;
  border-radius: 15px;
  height: 42px;
  padding: 0 12px;

  align-items: center;
  justify-content: center;
`;
